export default __webpack_public_path__ + "static/O0055-7b27cdbd37d960c699ea3d04e14e3977.png";